export const SWIFT_CARD_NUMBER_REGEX = /^[0-9]{18}$/;

export const validateSwiftCardNumber = (value: string) =>
  new RegExp(SWIFT_CARD_NUMBER_REGEX).test(value);
